import { createAsyncEvent } from '../../utils/analytics';

import {
  PASSWORD_REMINDER_EVENT_ACTION,
  PASSWORD_REMINDER_EVENT_CATEGORY,
  PASSWORD_REMINDER_EVENT_SUCCESS_LABEL,
  PASSWORD_REMINDER_EVENT_ERROR_LABEL_PREFIX,
  PASSWORD_REMINDER_EVENT_ABORT_LABEL
} from '../../AAF/Auth/authConstants';
import { setMetricsEvent } from '../../actions/metrics';

export default class PasswordLogic {

  constructor() {
    this.analyticsEvent = createAsyncEvent({
      send: event => {
        setMetricsEvent(event);
        setMetricsEvent({ type: 'executor' });
      },
      action: PASSWORD_REMINDER_EVENT_ACTION,
      category: PASSWORD_REMINDER_EVENT_CATEGORY,
      abortLabel: PASSWORD_REMINDER_EVENT_ABORT_LABEL,
      successLabel: PASSWORD_REMINDER_EVENT_SUCCESS_LABEL,
      errorLabelPrefix: PASSWORD_REMINDER_EVENT_ERROR_LABEL_PREFIX
    });
  }

  onReminderSuccess() {
    this.analyticsEvent.success();
  }

  onReminderError(err) {
    this.analyticsEvent.error(err);
  }
}



// WEBPACK FOOTER //
// ./src/authentication/PasswordReminder/PasswordLogic.js